var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"160px","cursor":"pointer"}},_vm._l((4),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"80px","margin":"5px 0 0 0"},attrs:{"src":_vm.src,"page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }